export default __webpack_public_path__ + "static/media/screen17.019b8ed1.svg";